export enum RaisonsSansNeq {
  EntrepriseHorsQuebec = 'EntrepriseHorsQuebec',
  Autre = 'Autre'
}
